import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';

export const StyledLabelWithUIGuidelines = styled.div<{
  theme: ICustomTheme;
  isMobile?: boolean;
  margin?: string;
}>`
  margin: ${({ margin }) => margin || 'none'};
  color: 'black';
  font-size: ${({ isMobile, theme }) =>
    `${
      isMobile ? theme.fontSizes.mobileLabel : theme.fontSizes.desktopLabel
    }px`};
`;
